"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Acceleration.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Acceleration = function Acceleration(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 197.5 197.5"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Acceleration Icon"), _react2.default.createElement("g", {
    className: "speed-dial",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "dial",
    d: "M98.75 0a98.75 98.75 0 1 0 98.75 98.75A98.75 98.75 0 0 0 98.75 0zm0 186.3a87.56 87.56 0 1 1 87.55-87.57 87.56 87.56 0 0 1-87.55 87.57z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "needle",
    d: "M95 94l59.72-36.54-46.46 52.23A10.37 10.37 0 0 1 92.9 95.83 10.75 10.75 0 0 1 95 94z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M98.75 59.2a3 3 0 0 1-3-3v-31a3 3 0 1 1 6 0v31a3 3 0 0 1-3 3zm-44.54 42.55h-31a3 3 0 0 1 0-6h31a3 3 0 0 1 0 6zm15.47-31.08a3 3 0 0 1-2.12-.88L45.64 47.87a3 3 0 0 1 4.24-4.24L71.8 65.55a3 3 0 0 1-2.12 5.12z",
    className: "indicators",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: undefined
  })));
};
exports.default = Acceleration;